import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class GoalsInsightsIndexRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;

	override beforeModel() {
		const firstGoal = this.mmGoalsService.goalModels[0]!;
		if (firstGoal) {
			this.navigationService.transitionToRoute('goals.insights.detail', firstGoal.model);
		} else {
			this.navigationService.transitionToRoute('goals.my');
		}
	}
}
